<template>

    <div>
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 权限管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>轮播图管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover"  class="containCard" >
            <el-button  type="primary"  icon="el-icon-lx-roundadd" class="fr mr10"  @click="addBind" >添加站点</el-button>
            <el-table :data="tableData" class="table"   row-key="id" lazy :load="load" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">>
                <el-table-column prop="stationName" min-width="120"   label="系统名称"> </el-table-column>
                <el-table-column prop="companyEmail" min-width="200"   label="公司信息">
                    <template slot-scope="scope">
                        <p style='font-size: 12px;'>
                            <b>联系电话:</b> {{scope.row.companyPhone}}<br>
                            <b>公司邮箱:</b> {{scope.row.companyEmail}}<br>
                            <b>公司名称:</b> {{scope.row.companyName}}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="companyEmail" min-width="420"   label="地址信息">
                    <template slot-scope="scope">
                       <p style='font-size: 12px;'>
                        <b>公司网址:</b> {{scope.row.stationUrl}}<br>
                           <b>公司地址:</b> {{scope.row.companyArea}}<br>
                           <b>备案信息:</b> {{scope.row.companyIsp}}
                       </p>
                    </template>
                </el-table-column>
                <el-table-column prop="img" min-width="90" align="center" label="系统logo">
                    <template slot-scope="scope">
                        <img :src="scope.row.stationLogo" style='width:60px;height:60px;' />
                    </template>
                </el-table-column>
                <el-table-column prop="img" min-width="90" align="center" label="联系我们">
                    <template slot-scope="scope">
                        <img :src="scope.row.linkUrl" style='width:60px;height:60px;' />
                    </template>
                </el-table-column>
                <el-table-column prop="status" width="90" align="center" label="是否显示">
                    <template slot-scope="scope" >
                        <el-tooltip :content="scope.row.status=='1'?'开启':'关闭'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                       v-model="scope.row.status"
                                       active-color=""
                                       inactive-color=""
                                       active-value="1"
                                       inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="fb1" min-width="80" align="left" label="排序ID"></el-table-column>
                <el-table-column prop="createTime" min-width="150" align="left" label="创建时间"></el-table-column>
                <el-table-column label="操作" min-width="145" align="center" fixed="right">
                    <template slot-scope="scope">
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </el-card>


        <!-- 新建代理渠道弹出框 -->
        <el-dialog stationName="添加站点" :modal-append-to-body='false' :visible.sync="addPlusVisible" top="80px" width="400px">
            <el-form ref="form1" :model="form1" label-width="90px" @submit.native.prevent="saveForm">
                <el-form-item label="系统名称" required >
                    <el-input  v-model.trim="form1.stationName"  placeholder="系统名称"></el-input>
                </el-form-item>
                <el-form-item label="公司名称" required >
                    <el-input  v-model.trim="form1.companyName"  placeholder="公司名称"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" required >
                    <el-input  v-model.trim="form1.companyPhone"  placeholder="联系电话"></el-input>
                </el-form-item>
                <el-form-item label="公司网址" required >
                    <el-input  v-model.trim="form1.stationUrl"  placeholder="公司网址"></el-input>
                </el-form-item>
                <el-form-item label="公司地址" required >
                    <el-input  v-model.trim="form1.companyArea"  placeholder="公司地址"></el-input>
                </el-form-item>
                <el-form-item label="备案信息" required >
                    <el-input  v-model.trim="form1.companyIsp"  placeholder="备案信息"></el-input>
                </el-form-item>
                <el-form-item label="公司邮箱" required >
                    <el-input  v-model.trim="form1.companyEmail"  placeholder="公司邮箱"></el-input>
                </el-form-item>
                <el-form-item label="系统logo" required >
                    <img :src="form1.stationLogo" style="width:60px;height:60px;margin-right:10px;vertical-align:middle">
                    <el-button @click="showIcon('1')">查找图片</el-button>
                </el-form-item>
                <el-form-item label="联系我们" required >
                    <img :src="form1.linkUrl" style="width:90px;height:90px;margin-right:10px;vertical-align:middle">
                    <el-button @click="showIcon('2')">查找图片</el-button>
                </el-form-item>
                <el-form-item label="排序" >
                    <el-input  v-model.trim="form1.fb1"  placeholder="数字越小，排序越靠前"></el-input>
                    <p>数字越小，排序越靠前</p>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提交' }}</el-button>
            </span>
        </el-dialog>



        <!-- 编辑代理渠道弹出框 -->
        <el-dialog stationName="编辑站点" :modal-append-to-body='false' :visible.sync="editPlusVisible" top="80px" width="520px">
            <el-form ref="form" :model="form3" label-width="90px">
                <el-form-item label="系统名称" required >
                    <el-input  v-model.trim="form3.stationName"  placeholder="系统名称"></el-input>
                </el-form-item>
                <el-form-item label="公司名称" required >
                    <el-input  v-model.trim="form3.companyName"  placeholder="公司名称"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" required >
                    <el-input  v-model.trim="form3.companyPhone"  placeholder="联系电话"></el-input>
                </el-form-item>
                <el-form-item label="公司网址" required >
                    <el-input  v-model.trim="form3.stationUrl"  placeholder="公司网址"></el-input>
                </el-form-item>
                <el-form-item label="公司地址" required >
                    <el-input  v-model.trim="form3.companyArea"  placeholder="公司地址"></el-input>
                </el-form-item>
                <el-form-item label="备案信息" required >
                    <el-input  v-model.trim="form3.companyIsp"  placeholder="备案信息"></el-input>
                </el-form-item>
                <el-form-item label="公司邮箱" required >
                    <el-input  v-model.trim="form3.companyEmail"  placeholder="公司邮箱"></el-input>
                </el-form-item>
                <el-form-item label="系统logo" required >
                    <img :src="form3.stationLogo" style="width:60px;height:60px;margin-right:10px;vertical-align:middle">
                    <el-button @click="showIcon('1')">查找图片</el-button>
                </el-form-item>
                <el-form-item label="联系我们" required >
                    <img :src="form3.linkUrl" style="width:90px;height:90px;margin-right:10px;vertical-align:middle">
                    <el-button @click="showIcon('2')">查找图片</el-button>
                </el-form-item>
                <el-form-item label="排序" >
                    <el-input  v-model.trim="form3.fb1"  placeholder="数字越小，排序越靠前"></el-input>
                    <p>数字越小，排序越靠前</p>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button @click="editPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog stationName="查找图标" :modal-append-to-body='false' :visible.sync="showVisible" top="80px" width="860px">
            <div style="width:100%;height:600px;overflow-y:scroll;margin-top:-30px;">
                <v-content2 ></v-content2>
            </div>
        </el-dialog>


    </div>
</template>

<script>
import bus from '../../../components/common/bus';
import {fetchData,saveForm,handDelete,changeForm,changeStatus} from './station';
import vContent2 from '../sysConfig/ComImg.vue';
export default {

    data() {
        return {
            Timeout:'',
            isSubmitting: false, // 是否正在提交
            select:{ option:'',  },
            select2:{ option:'',  },
            sendSms:{
                code:'',
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
            },

            query: {
                pageIndex: 1,
                pageSize: 10,
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            showVisible:false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false,
            dirVisible:false,
            row:{},
            pageTotal: 0,
            imgVal:'',
            form: {
                ids:'',
                names:'',
            },
            form1: {
                level:'1',
                fb1:10,
            },
            form2: {   },
            form3: {   },
            idx: -1,
            id: -1,
            // 获取row的key值

            // 要展开的行，数值的元素是row的key值

        };
    },
    created() {
        bus.$on('image-choose',  url  => {
            if(this.imgVal==1){
                this.form1.stationLogo = url;
                this.form3.stationLogo = url;
            }else if(this.imgVal==2){
                this.form1.linkUrl = url;
                this.form3.linkUrl = url;
            }
            this.showVisible = false;
        });
    },
    components: {
        vContent2,
    },
    //页面加载方法
    mounted: function () {
        //查询列表
        this.getData();

    },

    methods: {
        load(tree, treeNode, resolve) {
            setTimeout(() => {
                resolve(tree.subs);
            },200);

        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){
            this.$set(this.query, 'goodsCode');
            this.handleSearch();
        },

        //触发刷新按钮
        refresh(){
            history.go(0);

        },

        //获取下拉框数据
        getSelect(goodsCode){
            this.select.goodsCode = goodsCode;
            fetchSelect(this.select).then(res => {
                if(res.code=='200'){
                    this.select.option = res.data;
                }
            });
        },
        getSelect2(){
            this.select2.option = '';
            fetchSelect2(this.select2).then(res => {
                if(res.code=='200'){
                    this.select2.option = res.data;
                }
            });
        },
        showIcon(i){
            this.imgVal= i;
            this.showVisible=true;
        },

        //查询
        getData(){
            this.tableData = [];
            fetchData(this.query).then(res => {
                if(res.code=='200'){
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;
                }else{
                    this.tableData = [];
                    this.pageTotal = 0;
                }
            });
        },


        // 新增渠道
        addBind() {
            this.isSubmitting = false;
            this.addPlusVisible = true;

        },
        //保存新增
        saveForm() {
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if(  !this.form1.stationName ){
                this.isSubmitting = false;
                this.$message.error("请填写系统名称");
                return;
            }
            if(  !this.form1.stationUrl ){
                this.isSubmitting = false;
                this.$message.error("请填写公司网址");
                return;
            }
            if(  !this.form1.companyArea ){
                this.isSubmitting = false;
                this.$message.error("请填写公司地址");
                return;
            }
            if(  !this.form1.companyEmail ){
                this.isSubmitting = false;
                this.$message.error("请填写公司邮箱");
                return;
            }
            if(  !this.form1.stationLogo ){
                this.isSubmitting = false;
                this.$message.error("请选择系统logo");
                return;
            }
            if(  !this.form1.linkUrl ){
                this.isSubmitting = false;
                this.$message.error("请选择联系我们");
                return;
            }
            this.loading = true;
            saveForm(this.form1).then(res => {
                this.loading = false;
                this.isSubmitting = false;
                if(res.code=='200'){
                    this.$message.success(res.message);
                    this.refreshSearch();
                    localStorage.removeItem(window.location.hostname+'_items');
                    this.addPlusVisible = false;
                }else{
                    this.$message.error(res.message);
                }
            });
        },



        // 编辑操作
        handleEdit(index, row) {
            this.editPlusVisible = true;
            this.form3 = row;
        },


        // 保存更改
        saveEdit() {
            this.form3.mid = this.mid;
            this.form3.stationId = this.stationId;
            changeForm(this.form3).then(res => {
                if(res.code=='200'){
                    localStorage.removeItem(window.location.hostname+'_items');
                    this.editVisible = false;
                    this.editPlusVisible = false;
                    this.$message.success(res.message);
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {
            let data = {};
            data.id = row.id;
            data.status = row.status;
            data.stationId = this.stationId;
            data.mid = this.mid;
            var tips="开启站点";
            if(row.status==0){
                tips="关闭站点";
            }
            changeStatus(data).then(res => {
                if(res.code=='200'){
                    this.getData();
                    this.$message.success(tips+'成功');
                }else{
                    this.$message.error(res.message);
                }
            });
        },


        //详情
        handleDetail(index, row){
            this.form2 = row;
            if(row.channelType=='1'){
                this.detailVisible = true;
            }

        },
        // 删除
        handDelete(index, row) {
            this.form.id=row.id;
            this.form.mid = this.mid;
            this.form.stationId = this.stationId;
            // 二次确认删除
            this.$confirm('确定要删除该轮播图吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){
                        this.$message.success('删除成功');
                        this.getData();
                    }else{
                        this.$message.error("删除失败");
                    }
                });
            })
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr15 {
    margin-right: 15px;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    color: #555;
    width:100px;
    text-align:center;
}
.label-span{
    display: inline-block;
    height: 45px;
}
</style>
<style>
.demo-table-expand {
    font-size: 0;
}
.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}
.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}

.el-table thead{
    color: #666;
    font-weight: 500;
    font-size: 14px;
}

</style>
